import DepartmentDistribution from "./component/DepartementDistribution";
import EmployeesByJobLevel from "./component/EmployeeByLevels";
import Hierarchy from "./component/Hierarchy";
import OrganizationHeader from "./component/OrganizationHeader";
import OrganizationStats from "./component/OrganizationStats";
import TeamAllocationHeatmap from "./component/TeamAllocationHeatmap";


const OrgDashboard = () => {
  return (
    <main className="min-h-screen bg-slate-50 font-sans p-6 space-y-6">
      <OrganizationHeader/>
      <OrganizationStats/>
      <section className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-3 gap-6">
      <DepartmentDistribution/>
      <EmployeesByJobLevel/>
      <TeamAllocationHeatmap/>
      </section>
     <Hierarchy/>
    </main>
  );
};

export default OrgDashboard;

